import { RemixBrowser, useLocation, useMatches } from '@remix-run/react';
import * as Sentry from '@sentry/remix';
import { startTransition, StrictMode, useEffect } from 'react';
import { hydrateRoot } from 'react-dom/client';

type RootLoaderEnv = { SENTRY_DSN?: string };

const dsn =
    (
        window as unknown as {
            __remixContext?: {
                state?: {
                    loaderData?: {
                        root?: { env?: RootLoaderEnv };
                    };
                };
            };
        }
    ).__remixContext?.state?.loaderData?.root?.env?.SENTRY_DSN ?? '';

if (dsn) {
    Sentry.init({
        dsn,
        tracesSampleRate: 1,
        integrations: [
            Sentry.browserTracingIntegration({ useEffect, useLocation, useMatches }),
            Sentry.replayIntegration(),
            Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
        ],
        enableLogs: true,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1,
    });
}

startTransition(() => {
    hydrateRoot(
        document,
        <StrictMode>
            <RemixBrowser />
        </StrictMode>
    );
});
